import Enum from './enum'

class OperationSubject extends Enum
{
  constructor(value) {
    super(value);
  }
}

OperationSubject.init({
  BID: 'Bid',
  FILE: 'File',
  CRITERION: 'Criterion',
  SPECIFICATION: 'Specification',
  PARTS: 'Paymentpart',
  PAYMENTS: 'PaymentpartDo'
});

export default OperationSubject;
